import React from "react";
import EmployeeScheduleTemplateTable from "./components/EmployeeScheduleTemplateTable";

const EmployeeScheduleTemplate = ({}) => {
	
	return (
		<div className="grid h-full grid-cols-1 gap-4">
			<EmployeeScheduleTemplateTable/>
		</div>
    );
};


export default (EmployeeScheduleTemplate);